



import {Vue,Component, Prop, Emit} from 'vue-property-decorator';
import { styleBody } from '../../../common/interface/index';
@Component({
    name: 'MyIcon',
})
export default class MyIcon extends Vue{
    @Prop({
        type: String,
        required: true,
    })
    private icon!: string;
    @Prop({
        type: Number
    })
    private font!: number;
    @Prop({
        type: String
    })
    private color!: string;
    @Prop({
        type: String
    })
    private padding!: string;

    @Emit('click')
    click(...args: any){}

    get style() {
      const style: styleBody = {};
      this.font && (style.fontSize = this.font + "px");
      this.color && (style.color = this.color);
      this.padding && (style.padding = this.padding);
      return style;
    }
};
